import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

// TODO: TEMPORANEO - bypass proxy per debug, chiamate dirette al backend
// Settare a true per saltare il proxy e chiamare direttamente il backend
const BYPASS_PROXY = false;
const DIRECT_BACKEND = 'https://mysigncl.infocert.it';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
  // Domini per cui NON va iniettato l'Authorization header.
  // Oltre agli endpoint OAuth2/ISAC, includiamo l'endpoint ESG pubblico per evitare preflight CORS inutili.
  private oauthDomains = [
    'idp.infocert.it',
    'idpcl.infocert.it',
    'idp.eu-south-1.tsaws.infocert.it',
    'rinnovofirma.infocert.it/esg',
  ];

  constructor(private cookieService: CookieService) {}

  private isOAuthRequest(url: string): boolean {
    return this.oauthDomains.some(domain => url.includes(domain));
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Non intercettare le richieste OAuth2/ISAC (token, jwks, discovery) né ESG (no Bearer per evitare CORS preflight)
    if (this.isOAuthRequest(req.url)) {
      return next.handle(req);
    }

    const contentType =
      req.headers.get('Content-Type') || 'application/x-www-form-urlencoded';

    const accessToken = this.cookieService.get('oauth-access-token');
    const hasAuthHeader = req.headers.has('Authorization');
    const authHeader =
      accessToken && !hasAuthHeader ? `Bearer ${accessToken}` : undefined;
    if (authHeader) {
      console.log('[HTTP] Authorization header bearer (new):', authHeader);
    }

    // Bypass proxy: riscrive URL per chiamate dirette al backend
    let url = req.url;
    if (
      BYPASS_PROXY &&
      !environment.production &&
      url.startsWith('/ncfr-api')
    ) {
      url = DIRECT_BACKEND + url;
      console.log('🔀 BYPASS PROXY:', req.method, url);
    }

    //https://stackoverflow.com/a/48683560
    const request = req.clone({
      url,
      setHeaders: {
        'Content-Type': contentType,
        ...(authHeader ? { Authorization: authHeader } : {}),
      },
    });

    return next.handle(request);
  }
}
